export const DIAS_DA_SEMANA = [
    "DOMINGO",
    "SEGUNDA_FEIRA",
    "TERCA_FEIRA",
    "QUARTA_FEIRA",
    "QUINTA_FEIRA",
    "SEXTA_FEIRA",
    "SABADO",
];

export const DIAS_DA_SEMANA_LABEL = {
    DOMINGO: { nome: "Domingo", ordem: 0 },
    SEGUNDA_FEIRA: { nome: "Segunda-feira", ordem: 1 },
    TERCA_FEIRA: { nome: "Terça-feira", ordem: 2 },
    QUARTA_FEIRA: { nome: "Quarta-feira", ordem: 3 },
    QUINTA_FEIRA: { nome: "Quinta-feira", ordem: 4 },
    SEXTA_FEIRA: { nome: "Sexta-feira", ordem: 5 },
    SABADO: { nome: "Sábado", ordem: 6 },
};

const getDiaSemanaCodigo = (dataDaConsulta) => {
    if (!dataDaConsulta) {
        return null;
    }

    const [ano, mes, dia] = dataDaConsulta.split("-").map(Number);

    if (!ano || !mes || !dia) {
        return null;
    }

    return new Date(ano, mes - 1, dia).getDay();
};

export const getDiaSemanaChave = (dataDaConsulta) => {
    const diaCodigo = getDiaSemanaCodigo(dataDaConsulta);

    return diaCodigo === null ? null : DIAS_DA_SEMANA[diaCodigo];
};

export const normalizarData = (data) => {
    if (!data) {
        return "";
    }

    if (data instanceof Date) {
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, "0");
        const dia = String(data.getDate()).padStart(2, "0");

        return `${ano}-${mes}-${dia}`;
    }

    const texto = String(data).trim();

    if (texto.includes("T")) {
        return texto.split("T")[0];
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) {
        return texto;
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
        const [dia, mes, ano] = texto.split("/");
        return `${ano}-${mes}-${dia}`;
    }

    return texto.substring(0, 10);
};

export const formatarData = (data) => {
    const dataIso = normalizarData(data);

    if (!/^\d{4}-\d{2}-\d{2}$/.test(dataIso)) {
        return dataIso || "";
    }

    const [ano, mes, dia] = dataIso.split("-");
    return `${dia}/${mes}/${ano}`;
};

export const formatarHora = (hora) => {
    if (Array.isArray(hora)) {
        const [horaValor, minutoValor = 0] = hora;
        return `${String(horaValor).padStart(2, "0")}:${String(
            minutoValor,
        ).padStart(2, "0")}`;
    }

    return String(hora ?? "").substring(0, 5);
};

export const getDataAtendimentoEspecifico = (configuracao) =>
    normalizarData(
        configuracao?.dataAtendimento ??
            configuracao?.dataEspecifica ??
            configuracao?.dataDoAtendimento ??
            configuracao?.dataDiaExtra ??
            configuracao?.data ??
            "",
    );

export const getDataBloqueio = (configuracao) =>
    normalizarData(
        configuracao?.dataBloqueio ??
            configuracao?.dataBloqueada ??
            configuracao?.dataDoBloqueio ??
            (configuracao?.bloqueado ||
            configuracao?.bloqueio ||
            configuracao?.tipo === "BLOQUEIO" ||
            configuracao?.tipoConfiguracao === "BLOQUEIO"
                ? configuracao?.dataAtendimento ??
                  configuracao?.dataEspecifica ??
                  configuracao?.dataDoAtendimento ??
                  configuracao?.dataBloqueada ??
                  configuracao?.data
                : "") ??
            "",
    );

export const isConfiguracaoBloqueio = (configuracao) =>
    Boolean(
        getDataBloqueio(configuracao) ||
            configuracao?.bloqueado ||
            configuracao?.bloqueio ||
            configuracao?.tipo === "BLOQUEIO" ||
            configuracao?.tipoConfiguracao === "BLOQUEIO",
    );

export const isConfiguracaoEspecifica = (configuracao) =>
    Boolean(getDataAtendimentoEspecifico(configuracao)) &&
    !isConfiguracaoBloqueio(configuracao);

export const isConfiguracaoSemanal = (configuracao) =>
    Boolean(configuracao?.diasDaSemana) &&
    !isConfiguracaoEspecifica(configuracao) &&
    !isConfiguracaoBloqueio(configuracao);

const isHorarioDentroDoPeriodo = (horaConsulta, horaInicio, horaFim) => {
    if (!horaConsulta || !horaInicio || !horaFim) {
        return true;
    }

    const hora = formatarHora(horaConsulta);
    const inicio = formatarHora(horaInicio);
    const fim = formatarHora(horaFim);

    return hora >= inicio && hora <= fim;
};

export const isDiaAtendimento = (dataDaConsulta, diasDeAtendimento) => {
    if (!Array.isArray(diasDeAtendimento) || diasDeAtendimento.length === 0) {
        return true;
    }

    const diaCodigo = getDiaSemanaCodigo(dataDaConsulta);

    if (diaCodigo === null) {
        return true;
    }

    const diaTexto = DIAS_DA_SEMANA[diaCodigo];

    return (
        diasDeAtendimento.includes(diaCodigo) ||
        diasDeAtendimento.includes(diaTexto)
    );
};

export const validarAtendimentoDisponivel = ({
    dataDaConsulta,
    horaDaConsulta,
    configuracoesHorario = [],
    diasDeAtendimento = [],
}) => {
    const dataConsulta = normalizarData(dataDaConsulta);
    const configuracoes = Array.isArray(configuracoesHorario)
        ? configuracoesHorario
        : [];

    const possuiBloqueio = configuracoes.some(
        (configuracao) =>
            isConfiguracaoBloqueio(configuracao) &&
            getDataBloqueio(configuracao) === dataConsulta,
    );

    if (possuiBloqueio) {
        return {
            permitido: false,
            motivo: "Este profissional bloqueou atendimentos nesta data.",
        };
    }

    const configuracoesEspecificas = configuracoes.filter(
        isConfiguracaoEspecifica,
    );
    const atendimentoEspecifico = configuracoesEspecificas.find(
        (configuracao) =>
            getDataAtendimentoEspecifico(configuracao) === dataConsulta &&
            isHorarioDentroDoPeriodo(
                horaDaConsulta,
                configuracao.horaInicio,
                configuracao.horaFim,
            ),
    );

    if (atendimentoEspecifico) {
        return { permitido: true };
    }

    const configuracoesSemanais = configuracoes.filter(isConfiguracaoSemanal);

    if (configuracoesSemanais.length > 0) {
        const diaSemana = getDiaSemanaChave(dataConsulta);
        const atendeHorarioSemanal = configuracoesSemanais.some(
            (configuracao) =>
                configuracao.diasDaSemana === diaSemana &&
                isHorarioDentroDoPeriodo(
                    horaDaConsulta,
                    configuracao.horaInicio,
                    configuracao.horaFim,
                ),
        );

        return atendeHorarioSemanal
            ? { permitido: true }
            : {
                  permitido: false,
                  motivo: "Não é permitido gravar consulta nesse dia e horário, pois o profissional não irá atender.",
              };
    }

    return {
        permitido: isDiaAtendimento(dataConsulta, diasDeAtendimento),
        motivo: "Não é permitido gravar consulta nesse dia, pois o profissional não irá atender.",
    };
};
